import { render } from "./EditConfirmationModal.vue?vue&type=template&id=01991ceb&scoped=true"
import script from "./EditConfirmationModal.vue?vue&type=script&lang=js"
export * from "./EditConfirmationModal.vue?vue&type=script&lang=js"

import "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=01991ceb&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01991ceb"]])

export default __exports__